export default __webpack_public_path__ + "eda5f06d35007c723c050295909cfca0.mp3";